import { ServiceGroupRate } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { ServiceGroupRateQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';
export const GET_SERVICE_GROUP_RATES_FROM_SERVER = '[LABOUR OPERATIONS] Get Service Group Rates From Server';
export class GetServiceGroupRatesFromServer implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICE_GROUP_RATES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: ServiceGroupRateQueryParameters) {}
}

export const GET_SERVICE_GROUP_RATES_FROM_SERVER_SUCCESS =
  '[LABOUR OPERATIONS] Get Service Group Rates From Server Success';
export class GetServiceGroupRatesFromServerSuccess implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICE_GROUP_RATES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { serviceGroupRates: ServiceGroupRate[] }) {}
}

export const GET_SERVICE_GROUP_RATES_FROM_SERVER_FAILURE =
  '[LABOUR OPERATIONS] Get Service Group Rates From Server Failure';
export class GetServiceGroupRatesFromServerFailure implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICE_GROUP_RATES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type ServicegroupRatesAction =
  | GetServiceGroupRatesFromServer
  | GetServiceGroupRatesFromServerSuccess
  | GetServiceGroupRatesFromServerFailure;
